export const SPOT_GRAPHQL_ERROR = 'SPOT_GRAPHQL_ERROR';
